export const VALID_INCENTIVE_VALUES_ARRAY = [1, 2, 3, 5, 7, 10, 15, 20, 25, 30] as const;
export const VALID_INCENTIVE_VALUES = new Set(VALID_INCENTIVE_VALUES_ARRAY);
export type ValidIncentiveValue = typeof VALID_INCENTIVE_VALUES_ARRAY[number];

export const isValidIncentiveValue = (value: number | undefined): value is ValidIncentiveValue =>
  value !== undefined && VALID_INCENTIVE_VALUES.has(value as ValidIncentiveValue);
